import { msg, Trans } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import Container from "../../common/Container";
import Footer from "../../common/Footer";
import FooterButton from "../../common/FooterButton";
import useIsAnonymous from "../../common/lib/hooks/useIsAnonymous";
import KaAlert, { DisplayMessage } from "../../common/lib/KaAlert";
import StartOverButton from "../../common/StartOverButton";
import SwitchToMobileQRCode from "../../common/SwitchToMobileQRCode";
import { PurchaseOrder } from "../../UserFlow";
import { FooterProps } from "./StageOrderTypes";

export interface PurchaseOrderInfoProps extends FooterProps {
  purchaseOrder: PurchaseOrder;
  purchaseOrderInfoSelected: () => void;
  message: DisplayMessage | null,
  clearMessage: () => void,
  startOver: () => void;
}

export const PurchaseOrderInfo = (props: PurchaseOrderInfoProps) => {
  const { _ } = useLingui();
  const isAnonymous = useIsAnonymous();

  const formWidth = isAnonymous ? "w-65" : "w-75";

  const handleSubmit = () => {
    props.purchaseOrderInfoSelected();
  }

  return <Container title={_(msg`Load Information`)}>
    {isAnonymous && <>
      <StartOverButton startOver={props.startOver}/>
      <SwitchToMobileQRCode />
    </>}
    <div className={formWidth + " m-auto"}>
      <KaAlert displayMessage={props.message} onClose={props.clearMessage} />
      <label className="h2" htmlFor="orderNumber">
        <Trans>Enter Order Number</Trans>
      </label>
      <input
        type="text"
        id="orderNumber"
        className="form-control form-control-lg"
        value={props.purchaseOrder.number}
        disabled />

      <label className="h5 mt-4 mb-0"><Trans>Supplier</Trans></label>
      <p className="m-0 line-clamp-2">{props.purchaseOrder.supplier}</p>

      <label className="h5 mt-4 mb-0"><Trans>Product</Trans></label>
      <p className="m-0 line-clamp-2">{props.purchaseOrder.product}</p>

      <label className="h5 mt-4 mb-0"><Trans>Requested</Trans></label>
      <p className="m-0 line-clamp-2">{_(msg`${props.purchaseOrder.requested} lb`)}</p>
    </div>
    <Footer
      nextButton={<FooterButton
        onClick={handleSubmit}
        {...props.nextButton} />}
      backButton={<FooterButton {...props.backButton} />}
    />
  </Container>
}
